import { uniqueNamesGenerator, adjectives, colors, animals, names } from 'unique-names-generator';

// Constants
const MAX_PASSKEY_LENGTH = 30;

/**
 * Generates a random passkey with length validation
 * Uses recursive approach to ensure passkey length ≤ 30 characters
 */
export const generateRandomPasskey = (): string => {
  const dicts = [colors, adjectives, animals, names].sort(() => Math.random() - 0.5);
  const randomPasskey = uniqueNamesGenerator({
    dictionaries: dicts,
    separator: '',
    length: 4,
    style: 'capital',
  });

  // Ensure passkey doesn't exceed maximum length
  if (randomPasskey.length > MAX_PASSKEY_LENGTH) {
    return generateRandomPasskey(); // Recursively try again
  } else {
    return randomPasskey;
  }
};
